export default {
  gameLimit: 20,
  starSize: 50,
  starsHeight: 400,
  starsWidth: 400,
};
